"use strict";
import { ReactComponent as CompanyIcon } from "assets/svg/protofire.svg";
import { useMenuContent } from "components/NavBar/CompanyMenu/Content";
import { MenuLink } from "components/NavBar/CompanyMenu/MenuDropdown";
import { useTabsContent } from "components/NavBar/Tabs/TabsContent";
import deprecatedStyled, { useTheme } from "lib/styled-components";
import { Discord, Github, Twitter } from "pages/Landing/components/Icons";
import { Wiggle } from "pages/Landing/components/animations";
import { useMemo } from "react";
import { Anchor, Flex, Separator, Text, useIsDarkMode } from "ui/src";
import { iconSizes } from "ui/src/theme";
import { useTranslation } from "uniswap/src/i18n";
const SOCIAL_ICONS_SIZE = `${iconSizes.icon32}px`;
const SocialIcon = deprecatedStyled(Wiggle)`
  flex: 0;
  fill: ${(props) => props.theme.neutral1};
  cursor: pointer;
  transition: fill;
  transition-duration: 0.2s;
  &:hover {
    fill: ${(props) => props.$hoverColor};
  }
`;
const DAOLogo = deprecatedStyled.img`
  height: 48px;
  width: auto;
  cursor: pointer;
  transition: opacity 0.2s ease;
  &:hover {
    opacity: 0.8;
  }
`;
export function Socials({ iconSize }) {
  return <Flex row gap="$spacing24" maxHeight={iconSize} alignItems="flex-start">
    <SocialIcon><Anchor href="https://x.com/flow_blockchain" target="_blank"><Twitter size={iconSize} fill="inherit" /></Anchor></SocialIcon>
    <SocialIcon><Anchor href="https://github.com/onflow" target="_blank"><Github size={iconSize} fill="inherit" /></Anchor></SocialIcon>
    <SocialIcon><Anchor href="https://discord.com/invite/J6fFnh2xx6" target="_blank"><Discord size={iconSize} fill="inherit" /></Anchor></SocialIcon>
  </Flex>;
}
function FooterSection({ title, items }) {
  const theme = useTheme();
  return <Flex width={130} $md={{ width: "100%" }} flexGrow={0} flexShrink={1} flexBasis="auto" gap={10}>
    <Text variant="body1">{title}</Text>
    {items.map((item, index) => <MenuLink
      key={`footer_${title}_${index}}`}
      label={item.label}
      href={item.href}
      internal={item.internal}
      overflow={item.overflow}
      $hoverColor={theme.neutral1}
    />)}
  </Flex>;
}
export function Footer() {
  const { t } = useTranslation();
  const isDarkMode = useIsDarkMode();
  const tabsContent = useTabsContent({ includeNftsLink: false });
  const appSectionItems = useMemo(() => {
    return tabsContent.map((tab) => ({
      label: tab.title,
      href: tab.href,
      internal: true
    }));
  }, [tabsContent]);
  const sections = useMenuContent();
  const theme = useTheme();
  return <Flex
    maxWidth="100vw"
    width="100%"
    gap="$spacing24"
    pt="$none"
    px="$spacing48"
    pb={40}
    $lg={{ px: "$spacing40" }}
    style={{
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 10,
      backgroundColor: theme.surface1
    }}
  >
    <Separator />
    <Flex
      row
      alignItems="center"
      $md={{ flexDirection: "column", alignItems: "flex-start" }}
      width="100%"
      justifyContent="space-between"
    >
      <Text variant="body3">2025 Flow Aggregator</Text>
      <Anchor style={{ textDecoration: "none" }} href="https://protofire.io" target="_blank"><Text variant="body3" style={{ display: "flex", alignItems: "center" }}>
        {"Supported by "}
        <CompanyIcon style={{ marginLeft: 4, marginRight: 4 }} />
      </Text></Anchor>
      {
        /* <Flex row alignItems="center" gap="$spacing16">
          <Anchor textDecorationLine="none" href="https://uniswap.org/trademark" target="_blank">
            <PolicyLink>{t('common.trademarkPolicy')}</PolicyLink>
          </Anchor>
          <PolicyLink href="/privacy">{t('common.privacyPolicy')}</PolicyLink>
        </Flex> */
      }
    </Flex>
  </Flex>;
}
